import { Fetcher } from '../../Fetcher';

import type { FetchSessionBalanceParams, SessionBalanceRequest, SessionBalanceResponse } from './types';

// Post session balance
export const fetchSessionBalance = ({
  url,
  ck,
  JSESSIONID,
  body,
}: FetchSessionBalanceParams): Promise<SessionBalanceResponse> => {
  return Fetcher.fetch<SessionBalanceResponse, SessionBalanceRequest>(url, {
    params: {
      ck,
      JSESSIONID,
    },
    headers: {
      'Content-Type': 'application/json',
    },
    body,
    method: 'POST',
  });
};
